import { useCurrentEditor } from '@tiptap/react';
import { useEffect } from 'react';

interface RichTextEditorSideEffectsProps {
  isEditable?: boolean;
  shouldFocus?: boolean;
}

export function RichTextEditorSideEffects({
  isEditable,
  shouldFocus,
}: RichTextEditorSideEffectsProps) {
  const { editor } = useCurrentEditor();

  useEffect(() => {
    if (!editor) {
      return;
    }

    if (isEditable) {
      editor.setEditable(true);
    } else {
      editor.setEditable(false);
    }
  }, [editor, isEditable]);

  useEffect(() => {
    if (!editor) {
      return;
    }

    if (shouldFocus) {
      editor.view.dom.focus();
    }
  }, [editor, shouldFocus]);

  return null;
}
